import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "assests/images";
import { FamilyOrFriendForm } from "components";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { IValidationParms } from "utility/interfaces/common/validation-parms";
import { IFamilyFriendDetails } from "utility/interfaces/create-request/create-request-details";
import { familyFriendFormSchema } from "utility/validations";

const FamilyFriendRequest: React.FC = () => {
  // Page level variables
  const navigate = useNavigate();

  // state variables
  const [familyFriendDetails, setFamilyFriendDetails] =
    useState<IFamilyFriendDetails>({
      friendEmail: "",
      friendFirstName: "",
      friendLastName: "",
      friendPhoneNumber: "",
      isRequestorSMSOpted: false,
      relationWithPatient: "",
      radioRequestorPhoneType: "M",
      patientDetails: {
        symptoms: "",
        firstName: "",
        lastName: "",
        birthDate: "",
        email: "",
        phoneNumber: "",
        isPatientSMSOpted: false,
        radioClientPhoneType: "M",
        street: "",
        city: "",
        state: "",
        zipCode: "",
        room: "",
        document: "",
        documentName: "",
        clientRegionId: 0,
      },
    });

  // handle events and function
  const handleOnBackButtonClick = () => {
    navigate(AppRoutings.CreateRequest);
  };

  const onChangeFamilyFriendDetails = (name: string, value: any) => {
    setFamilyFriendDetails({ ...familyFriendDetails, [name]: value });
  };

  // Yup resolver and validation
  const {
    register: familyFriendFormRegister,
    handleSubmit: familyFriendFormHandleSubmit,
    formState: { errors: familyFriendFormErrors },
    reset: familyFriendFormReset,
    clearErrors: familyFriendFormClearErrors,
    setValue: familyFriendFormSetValue,
    setError: familyFriendFormSetError,
  } = useForm({
    reValidateMode: "onSubmit",
    values: familyFriendDetails,
    resolver: yupResolver(familyFriendFormSchema),
  });
  const familyFriendFormValidation: IValidationParms = {
    register: familyFriendFormRegister,
    handleSubmit: familyFriendFormHandleSubmit,
    errors: familyFriendFormErrors,
    reset: familyFriendFormReset,
    clearErrors: familyFriendFormClearErrors,
    setValue: familyFriendFormSetValue,
    setError: familyFriendFormSetError,
  };

  return (
    <>
      <main className="main-content">
        <div
          className="overlay"
          onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
        ></div>

        <Box className="request-container-box">
          <div className="request-header">
            <div></div>
            <Button onClick={handleOnBackButtonClick} variant="outlined">
              <img src={ArrowBack} alt="arrow" />
              Back
            </Button>
          </div>

          <FamilyOrFriendForm
            handleOnBackButtonClick={handleOnBackButtonClick}
            validationParams={familyFriendFormValidation}
            details={familyFriendDetails}
            onChangeDetails={onChangeFamilyFriendDetails}
          />
        </Box>
      </main>
    </>
  );
};

export default FamilyFriendRequest;
